<template>
    <div style="overflow: auto;border-radius: inherit">
        <block class="loading-deep" v-if="loading"></block>
        <v-container class="white" style="max-width: 100% !important; overflow-y: scroll; max-height: 85vh;">
            <div class="box navbar " style="min-width: 250px; justify-content: space-around;flex-wrap: wrap;">
                <v-btn
                    v-if="loading == false && (order.data.OrderProcessed == 0 || order.data.OrderProcessed == false) && (rolesStatus.findIndex((role) => role.RoleName == 'admin') > -1 || rolesStatus.findIndex((role) => role.RoleName == 'root') > -1 || rolesStatus.findIndex((role) => role.ID_Role == 280) > -1)"
                    color="btndelete" dark large @click.prevent="showDelAlert = true">
                    ELIMINAR
                    <br>
                    ORDEN
                </v-btn>
                <v-btn
                    v-if="loading == false && (order.data.OrderProcessed == 1 || order.data.OrderProcessed == true) && (rolesStatus.findIndex((role) => role.RoleName == 'admin') > -1 || rolesStatus.findIndex((role) => role.RoleName == 'root') > -1 || rolesStatus.findIndex((role) => role.ID_Role == 280) > -1)"
                    color="btndelete" dark large @click.prevent="showDelAlert = true">
                    ELIMINAR
                    <br>
                    ORDEN
                </v-btn>


                <div class="input-group mb-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="IVA">SUB TOTAL</span>
                    </div>
                    <input type="text" class="form-control" v-model="purchaseOrderData.PurchaseOrderSubTotal" disabled
                        aria-describedby="IVA">
                </div>


                <div>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="EXENTAS">IVA (US$)</span>
                        </div>
                        <input type="text" class="form-control" v-model="purchaseOrderData.PurchaseOrderTotalIVA"
                            disabled aria-describedby="EXENTAS">
                    </div>
                </div>

                <div>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="EXENTAS">EXENTO (US$)</span>
                        </div>
                        <input type="text" class="form-control" v-model="purchaseOrderData.PurchaseOrderExento"
                            disabled aria-describedby="EXENTAS">
                    </div>
                </div>

                <div>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="EXENTAS">NO SUJ. (US$)</span>
                        </div>
                        <input type="text" class="form-control" v-model="purchaseOrderData.PurchaseOrderNoSujeto"
                            disabled aria-describedby="EXENTAS">
                    </div>
                </div>

                <div v-if="purchaseOrderData.PurchaseOrderTotalRet > 0">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="EXENTAS">IVA Ret. (US$)</span>
                        </div>
                        <input type="text" class="form-control" v-model="purchaseOrderData.PurchaseOrderTotalRet"
                            disabled aria-describedby="EXENTAS">
                    </div>
                </div>

                <div v-if="purchaseOrderData.PurchaseOrderIvaPerc > 0">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="EXENTAS">IVA Per. (US$)</span>
                        </div>
                        <input type="text" class="form-control" v-model="purchaseOrderData.PurchaseOrderIvaPerc"
                            disabled aria-describedby="EXENTAS">
                    </div>
                </div>

                <div v-if="purchaseOrderData.PurchaseOrderReteRenta > 0">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="EXENTAS">Rete Renta. (US$)</span>
                        </div>
                        <input type="text" class="form-control" v-model="purchaseOrderData.PurchaseOrderReteRenta"
                            disabled aria-describedby="EXENTAS">
                    </div>
                </div>

                <div v-if="purchaseOrderData.Flete > 0">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="EXENTAS">FLETE (US$)</span>
                        </div>
                        <input type="text" class="form-control" v-model="purchaseOrderData.Flete"
                            disabled aria-describedby="EXENTAS">
                    </div>
                </div>

                <div v-if="purchaseOrderData.Seguro > 0">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="EXENTAS">SEGURO (US$)</span>
                        </div>
                        <input type="text" class="form-control" v-model="purchaseOrderData.Seguro"
                            disabled aria-describedby="EXENTAS">
                    </div>
                </div>

                <div class="input-group ">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="VENTAS-TOTAL">VENTA TOTAL(US$)</span>
                    </div>
                    <input type="text" class="form-control" v-model="purchaseOrderData.PurchaseOrderTotal" disabled
                        aria-describedby="VENTAS-TOTAL">
                </div>

                <v-btn
                class=""
                    v-if="order.data.OrderProcessed == 0 &&
                        (rolesStatus.findIndex((role) => role.RoleName == 'admin') > -1 || rolesStatus.findIndex((role) => role.RoleName == 'root') > -1 || rolesStatus.findIndex((role) => role.ID_Role == 281) > -1)"
                    color="btn-save" dark large @click="editOrder">
                    EDITAR
                    <br>
                    ORDEN
                </v-btn>
                
                <v-btn
                    v-esle
                  
                    color="btn-save" dark large @click="print = {
                          show: true,
                          data: {
                            header: purchaseOrderData,
                            extraHeader: { },
                            body: orderItems,
                            totalinvoice: purchaseOrderData,
                            hideLotAndExpiration: hideLotAndExpiration,
                            showUsers: showUsers,
                        },
                        }">
                    IMPRIMIR
                    <br>
                    ORDEN
                </v-btn>
                <!--                <v-btn color="green" dark>-->
                <!--                    PROCESS-->
                <!--                    <br>-->
                <!--                    PURCHASE ORDER-->
                <!--                </v-btn>-->

                <!--v-col cols="12" md="2" >
                    <v-btn v-if="order.data.orderprocessed" color="btn-save" dark large class="mx-2" @click.prevent.stop="updatePurchaseOrder()">
                                PROCESAR
                                <br>
                                ORDEN
                    </v-btn>
                </v-col-->

            </div>
            <div class="order-header-section mb-4">
                <v-row align="center" class="mb-1">
                    <v-col cols="12" md="6" class="py-2 pt-4">
                        <span :class="$vuetify.breakpoint.smAndDown?'':'text-h6'">Detalles de la orden: {{ purchaseOrderId }}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6" md="3" class="py-1">
                        <v-text-field outlined dense readonly v-model="purchaseOrderData.PurchaseOrderDate"
                            label="Fecha de orden"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" class="py-1">
                        <v-text-field outlined dense readonly
                            v-model="purchaseOrderData.ID_Provider"
                            label="ID proveedor"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-1">
                        <v-text-field outlined dense readonly
                            v-model="purchaseOrderData.PurchaseOrderName"
                            label="Proveedor"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mb-0">
                    <v-col cols="12" class="py-1">
                        <span class="caption">
                            <b>Período CSV:</b> {{ getCustomPeriodLabel() }}
                        </span>
                    </v-col>
                </v-row>
            </div>

            <!-- Clasificación para anexos -->
            <v-row class="mt-4 mb-4">
                <v-col cols="12">
                    <v-card outlined class="pa-6">
                        <v-row align="center" class="mb-2">
                            <v-col>
                                <h3>Clasificación para anexos</h3>
                            </v-col>
                            <v-col cols="auto">
                                <template v-if="!editingClassification">
                                    <v-btn small color="secondary" @click="startEditClassification()">
                                        <v-icon small class="mr-1">mdi-pencil</v-icon>
                                        Editar
                                    </v-btn>
                                </template>
                                <template v-else>
                                    <v-btn small color="primary" class="mr-2" @click="saveClassification()">
                                        <v-icon small class="mr-1">mdi-content-save</v-icon>
                                        Guardar
                                    </v-btn>
                                    <v-btn small color="grey" @click="cancelEditClassification()">
                                        <v-icon small class="mr-1">mdi-close</v-icon>
                                        Cancelar
                                    </v-btn>
                                </template>
                            </v-col>
                        </v-row>

                        <!-- Modo lectura -->
                        <template v-if="!editingClassification">
                            <v-row>
                                <v-col cols="12" md="4">
                                    <p class="mb-1"><b>Clasificación (Renta):</b> {{ getClasificationRentLabel(purchaseOrderData.ClasificationRent) }}</p>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="mb-1"><b>Sector:</b> {{ getSectorLabel(purchaseOrderData.SectorProveedores) }}</p>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="mb-1"><b>Tipo de Costo / Gasto:</b> {{ getTipoIngresoLabel(purchaseOrderData.TipoIngresoProveedores) }}</p>
                                </v-col>
                            </v-row>
                        </template>

                        <!-- Modo edición -->
                        <template v-else>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <ClasificationRentaAutocomplete v-model="editClassificationData.ClasificationRent" />
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select outlined dense v-model="editClassificationData.SectorProveedores" :items="sectorProveedoresList" item-text="Valores" item-value="Codigo" label="Sector" attach clearable></v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select outlined dense v-model="editClassificationData.TipoIngresoProveedores" :items="tipoIngresoProveedoresList" item-text="Valores" item-value="Codigo" label="Tipo de Costo / Gasto" attach clearable></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <small>Los campos <b>Tipo de Costo / Gasto</b> y <b>Sector</b> son opcionales; si no se seleccionan, se tomarán los valores predeterminados del proveedor.</small>
                                </v-col>
                            </v-row>
                        </template>
                    </v-card>
                </v-col>
            </v-row>

            <v-row class="mt-4">
                <v-col cols="12" sm="6" class="pb-2">
                    <h3 :class="purchaseOrderData.PurchaseOrderInternalNote ? 'tabsContent' : 'tabs'"
                        @click="showComment = !showComment">
                        <center>Notas internas de la orden de compra</center>
                    </h3>
                </v-col>
                <v-col cols="12" sm="6" class="pb-2">
                    <h3 class="tabs" style="text-align: center;" @click="showInfoPurchase = !showInfoPurchase">
                        Datos de la factura
                    </h3>
                </v-col>
                <v-dialog v-model="showComment" scrollable max-width="1000">
                    <v-card class="pa-4">

                        <v-card-title style="display: flex;justify-content: space-between;">
                            <p class="text-h5">Notas internas de la orden de compra</p>
                            <div style="margin-bottom: .3rem; display: flex;justify-content: flex-end;">
                                <v-btn small class="btndelete" @click.prevent="showComment = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-card-title>
                        <v-card-text class="mt-2">
                            <v-col cols="12">
                                <div class="">
                                    <quill-editor :content="purchaseOrderData.PurchaseOrderInternalNote"
                                        @change="onEditorChange($event)" :readonly="readonly"
                                        :disabled="true"></quill-editor>
                                </div>
                            </v-col>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="showInfoPurchase" scrollable :max-width="$vuetify.breakpoint.smAndDown?'95%':'78%'">
                    <v-card class="d-flex flex-column" style="max-height: 92vh; padding: 16px !important;">
                        <v-card-title style="display: flex;justify-content: space-between;">
                            <p class="text-h5">Información de compra</p>
                            <div style="margin-bottom: .3rem; display: flex;justify-content: flex-end;">
                                <v-btn v-if="!editingInvoiceData" small color="secondary" class="mr-2" @click="startEditInvoiceData">
                                    <v-icon small class="mr-1">mdi-pencil</v-icon>
                                    Editar encabezado
                                </v-btn>
                                <template v-else>
                                    <v-btn small color="primary" class="mr-2"
                                        :loading="savingInvoiceData"
                                        :disabled="savingInvoiceData"
                                        @click="saveInvoiceData">
                                        <v-icon small class="mr-1">mdi-content-save</v-icon>
                                        Guardar
                                    </v-btn>
                                    <v-btn small color="grey" class="mr-2" @click="cancelEditInvoiceData">
                                        <v-icon small class="mr-1">mdi-close</v-icon>
                                        Cancelar
                                    </v-btn>
                                </template>
                                <v-btn small class="btndelete" @click.prevent="showInfoPurchase = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-card-title>

                        <v-card-text class="flex-grow-1 overflow-y-auto overflow-x-hidden mt-4 pa-4">
                            <v-row class="mt-0 mx-0">

                                <v-col cols="12" md="2">
                                    <center><v-img :src="url" style="width: 150px !important; height: 150px;" class="preview-avatar"></v-img></center>
                                    <br/>
                                    <center>
                                        <a :href="url" style="vertical-align: bottom; border-radius: 5px;" class="btn btn-save pa-3" target="_blank" rel="noopener" v-if="url">Ver documento</a>
                                        <p v-else>Compra sin documento de facturación.</p>
                                    </center>
                                    <br/>

                                </v-col>

                                <v-col cols="12" md="10">
                                    <v-row class="pt-1 mx-0">
                                        
                                        <v-col cols="12" md="6" class="mb-3">
                                            <date-picker class="w-100"
                                                :value="editInvoiceData.PurchaseInvoiceDate"
                                                label="Fecha de la factura"
                                                :disbaled="!editingInvoiceData"
                                                @dateSelected="editInvoiceData.PurchaseInvoiceDate = $event">
                                            </date-picker>
                                        </v-col>
                                        <v-col cols="12" md="6" class="mb-3">
                                            <date-picker class="w-100"
                                                :value="editInvoiceData.PurchaseOrderDate"
                                                label="Fecha de orden"
                                                :disbaled="!editingInvoiceData"
                                                @dateSelected="editInvoiceData.PurchaseOrderDate = $event">
                                            </date-picker>
                                        </v-col>

                                        <v-col cols="12" md="6">
                                            <v-select outlined dense attach :items="invoiceTypes"
                                                item-text="text" item-value="value"
                                                v-model="editInvoiceData.PurchaseOrderType"
                                                readonly
                                                label="Tipo de factura"></v-select>
                                        </v-col>
                                        <v-col cols="12" md="6" v-if="editInvoiceData.PurchaseOrderType != 'FNS'">
                                            <v-text-field outlined dense
                                                v-model="editInvoiceData.ID_PurchaseLegalInvoiceNumber"
                                                :label="getPurchaseDocumentNumberLabel()"
                                                :readonly="!editingInvoiceData"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-select outlined dense attach
                                                v-model="editInvoiceData.PurchaseDocumentType"
                                                :items="documentTypes" item-text="text" item-value="value"
                                                :readonly="!editingInvoiceData || editInvoiceData.PurchaseOrderType == 'FNS'"
                                                label="Tipo de documento"></v-select>
                                        </v-col>
                                        <v-col cols="12" md="6" v-if="shouldShowElectronicDocumentFields()">
                                            <v-text-field outlined dense
                                                v-model="editInvoiceData.NumeroControl" label="Número de control"
                                                :readonly="!editingInvoiceData"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" v-if="shouldShowElectronicDocumentFields()">
                                            <v-text-field outlined dense
                                                v-model="editInvoiceData.selloRecibido" label="Sello Recibido"
                                                placeholder="Sello de validación del MH"
                                                :readonly="!editingInvoiceData"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" v-if="editInvoiceData.PurchaseOrderType == 'NC' || editInvoiceData.NumeroDocumentoRelacionado">
                                            <v-text-field outlined dense readonly
                                                v-model="editInvoiceData.NumeroDocumentoRelacionado"
                                                label="Doc. relacionado"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field outlined dense v-model="editInvoiceData.paymenMethod" :readonly="!editingInvoiceData"
                                                label="Método de Pago"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-autocomplete outlined dense attach
                                                v-model="editInvoiceData.InvoiceState" :items="invoiceStatus"
                                                :readonly="!editingInvoiceData"
                                                label="Estado de la Factura"></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="6" v-if="editInvoiceData.InvoiceState == 'Crédito'">
                                            <v-select outlined dense attach
                                                v-model="editInvoiceData.days"
                                                :items="invoiceDays"
                                                :readonly="!editingInvoiceData"
                                                label="Plazo"></v-select>
                                        </v-col>
                                        <v-col cols="12" md="6" v-if="editInvoiceData.paymenMethod != 'Billetes y monedas' && editInvoiceData.paymenMethod != undefined">
                                            <v-text-field outlined dense
                                                v-model="editInvoiceData.NReference" :readonly="!editingInvoiceData" label="N. Referencia">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" class="pt-0">
                                            <v-card outlined class="pa-2">
                                                <v-row align="start" class="ma-0">
                                                    <v-col cols="12" class="py-1">
                                                        <v-checkbox dense hide-details class="mt-1"
                                                            v-model="editInvoiceData.CustomCSVPeriodFlag"
                                                            :true-value="1" :false-value="0"
                                                            label="Período personalizado para CSV's"
                                                            :disabled="!editingInvoiceData"></v-checkbox>
                                                    </v-col>
                                                    <v-col cols="12" class="py-1">
                                                        <v-row class="ma-0">
                                                            <v-col cols="12" md="6" class="py-1">
                                                                <v-select outlined dense attach
                                                                    v-model="editInvoiceData.CustomCSVPeriodMonth"
                                                                    :items="customPeriodMonths" item-text="text" item-value="value"
                                                                    label="Mes"
                                                                    :readonly="!editingInvoiceData || !isCustomPeriodEnabled(editInvoiceData.CustomCSVPeriodFlag)"></v-select>
                                                            </v-col>
                                                            <v-col cols="12" md="6" class="py-1">
                                                                <v-text-field outlined dense type="number"
                                                                    v-model="editInvoiceData.CustomCSVPeriodYear"
                                                                    label="Año"
                                                                    :readonly="!editingInvoiceData || !isCustomPeriodEnabled(editInvoiceData.CustomCSVPeriodFlag)"></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>

                    </v-card>
                    <alerts v-if="alert.show && showInfoPurchase"
                        v-on:close_alert="closeAlert"
                        v-on:accept_alert="acceptAlert"
                        :properties="alert">
                    </alerts>

                </v-dialog>
            </v-row>
            <v-row class="my-9 shadow border-5 pa-4 mx-2 align-center">
                <v-col cols="12" md="4" class="title py-2">
                    Elementos de la factura
                </v-col>
                <v-col cols="12" md="6" class="py-2">
                    <div class="d-flex flex-column flex-sm-row flex-wrap align-start align-sm-center">
                        <v-checkbox
                            v-model="hideLotAndExpiration"
                            dense
                            hide-details
                            class="mr-sm-4 mb-2 mb-sm-0"
                            label="No mostrar lote y fecha de expiración"
                        ></v-checkbox>
                        <v-checkbox
                            v-model="showUsers"
                            dense
                            hide-details
                            class="mb-0"
                            label="Mostrar usuarios"
                        ></v-checkbox>
                    </div>
                </v-col>
                <v-col cols="12" md="2" class="py-2 d-flex justify-start justify-md-end">
                    <v-btn class="btn btn-save export-detail-button" @click="onExporting()">Exportar detalle</v-btn>
                </v-col>
                <v-col cols="12">
                    <div class=" ">
                        <DxDataGrid 
                            ref="purchaseOrderDetailsGrid"
                            :scrolling="{useNative:true}" 
                            :data-source="orderItems" 
                            key-expr="ID_Item" 
                            @exporting="onExporting"
                        >
                            <DxExport :enabled="true" />
                            <DxColumn :width="columnWidth" data-field="ID_Item" caption="ID de Producto"></DxColumn>
                            <DxColumn :width="columnWidth" data-field="BarCode" caption="Código alterno"></DxColumn>
                            <DxColumn v-if="!hideLotAndExpiration" cell-template="lote-template" :width="columnWidth" caption="Lote"></DxColumn>
                            <template #lote-template="{ data }">
                                {{ data.data.ID_ItemBatch || data.data.InvID_ItemBatch }}
                            </template>
                            <DxColumn v-if="!hideLotAndExpiration" :width="columnWidth" data-field="ExpirationDate" caption="Fecha de expiración"></DxColumn>
                            <DxColumn :width="columnWidth" data-field="ItemName" caption="Nombre de Producto"></DxColumn>
                            <DxColumn :width="columnWidth" data-field="ItemQuantity" caption="Cantidad"></DxColumn>
                            <DxColumn :width="columnWidth" data-field="ItemUnitCost" caption="P. Unit."></DxColumn>
                            <DxColumn :width="columnWidth" :calculate-cell-value="getGravada" caption="Gravado"></DxColumn>
                            <DxColumn :width="columnWidth" data-field="ItemExento" caption="Exento"></DxColumn>
                            <DxColumn :width="columnWidth" data-field="ItemNoSujeto" caption="No Sujeto"></DxColumn>
                            <DxColumn v-if="showUsers" :width="columnWidth" data-field="UserInsertName" caption="Inserta"></DxColumn>
                            <DxColumn v-if="showUsers" :width="columnWidth" data-field="UserUpdateName" caption="Actualiza"></DxColumn>
                            <DxColumn :width="columnWidth" data-field="ItemTotalCost" caption="Total"></DxColumn>
                        </DxDataGrid>

                    </div>
                </v-col>
            </v-row>
            <v-divider></v-divider>

            <v-dialog v-model="showDelAlert" max-width="500">
                <v-card v-if="showDelAlert" class="text-center">
                    <v-card-title class="text-h5">
                        Esta seguro con eliminar la orden de compra ?
                    </v-card-title>

                    <v-btn v-if="(order.data.OrderProcessed == 0 || order.data.OrderProcessed == false)" class="ma-2" large color="info" @click="deleteOrder">
                        Si
                    </v-btn>
                    <v-btn v-if="(order.data.OrderProcessed == 1 || order.data.OrderProcessed == true)" class="ma-2" large color="info" @click="deleteProcessedOrder">
                        Si
                    </v-btn>

                    <v-btn class="ma-2" large color="error" @click="showDelAlert = false">
                        No
                    </v-btn>
                </v-card>
            </v-dialog>

        </v-container>
        <alerts v-if="alert.show && !showInfoPurchase" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
        </alerts>

        <print-purchase-order :data="print"></print-purchase-order>
    </div>
</template>

<script>
import { DxDataGrid, DxColumn, DxExport } from 'devextreme-vue/data-grid';
import Alerts from "@/components/Alerts";
import { mapState, mapGetters } from "vuex";
import PrintPurchaseOrder from "../../components/ReportsAndPrintings/PrintPurchaseOrder";
import ClasificationRentaAutocomplete from "../../components/Misc/ClasificationRentaAutocomplete.vue";
import { printToExcel } from "@/helpers/printToexcel";
import Block from "@/components/Block";
import DatePicker from "@/components/DatePicker";

export default {
    name: "PurchaseOrderDetails",
    components: { DxDataGrid, DxColumn, DxExport, Alerts, PrintPurchaseOrder, ClasificationRentaAutocomplete, Block, DatePicker },
    props: {
        order: {
            type: Object,

        },
        out: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            form: {},
            url: this.order.data.PurchaseOrderImage,
            image: null,
            showFilter: false,
            showModal: false,
            showDelAlert: false,
            purchaseOrderId: this.order.data.ID_PurchaseOrder,
            invoiceTypes: [],
            invoiceStatus: ["Pendiente de pago", "Cancelada", "Crédito"],
            invoiceDays: ["8 Dias", "15 Dias", "30 Dias", "90 Dias", "120 Dias", "180 Dias"],
            documentTypes: [
                { text: 'Físico', value: 1 },
                { text: 'Electrónico', value: 2 },
            ],
            customPeriodMonths: [
                { text: 'Enero', value: 1 },
                { text: 'Febrero', value: 2 },
                { text: 'Marzo', value: 3 },
                { text: 'Abril', value: 4 },
                { text: 'Mayo', value: 5 },
                { text: 'Junio', value: 6 },
                { text: 'Julio', value: 7 },
                { text: 'Agosto', value: 8 },
                { text: 'Septiembre', value: 9 },
                { text: 'Octubre', value: 10 },
                { text: 'Noviembre', value: 11 },
                { text: 'Diciembre', value: 12 },
            ],
            purchaseOrderData: this.order.data,
            orderItems: [],
            readonly: true,
            disabled: true,
            showComment: false,
            showInfoPurchase: false,
            print: {
                show: false,
                data: [],
            },
            hideLotAndExpiration: false,
            showUsers: false,
            // Edición de clasificación
            editingClassification: false,
            editClassificationData: {},
            // Edición de datos de factura
            editingInvoiceData: false,
            editInvoiceData: {
                PurchaseOrderDate: this.order.data.PurchaseOrderDate,
                PurchaseInvoiceDate: this.order.data.PurchaseInvoiceDate,
                PurchaseOrderType: this.order.data.PurchaseOrderType,
                ID_PurchaseLegalInvoiceNumber: this.order.data.ID_PurchaseLegalInvoiceNumber,
                PurchaseDocumentType: this.order.data.PurchaseDocumentType,
                NumeroControl: this.order.data.NumeroControl,
                selloRecibido: this.order.data.selloRecibido,
                NumeroDocumentoRelacionado: this.order.data.NumeroDocumentoRelacionado,
                CustomCSVPeriodFlag: this.order.data.CustomCSVPeriodFlag ? 1 : 0,
                CustomCSVPeriodYear: this.order.data.CustomCSVPeriodYear || new Date().getFullYear(),
                CustomCSVPeriodMonth: this.order.data.CustomCSVPeriodMonth,
                paymenMethod: this.order.data.paymenMethod,
                InvoiceState: this.order.data.InvoiceState,
                days: this.order.data.days,
                NReference: this.order.data.NReference,
            },
            loading: false,
            savingInvoiceData: false,
        }
    },
    created() {
        this.$store.dispatch('getParam', { type: 'Invoice' }).then((data) => {
            this.invoiceTypes = data.map((param) => {
                return { text: param.ParameterName, value: param.ParameterValue }
            })

            // console.log(this.invoiceTypes)
        });

    },

    mounted() {
        // console.log("INFORMACIÓN DE LA ORDEN DE COMPRA", this.purchaseOrderData)
        this.$store.dispatch('rolesUser/getAllRoles')
        this.$API.orders.getProductItems(this.purchaseOrderId)
            .then(response => {
                this.orderItems = response;
            })

    },
    computed: {
        ...mapState(
            "rolesUser",
            {
                rolesStatus: (state) => state.roles,
            }),
        columnWidth() {
            return this.$vuetify.breakpoint.smAndDown ? '150px' : 'auto !important';
        },
        tipoIngresoProveedoresList() {
            return this.getCatalogMH('TipoIngresoProveedores');
        },
        sectorProveedoresList() {
            return this.getCatalogMH('SectorProveedores');
        },
        comprasClasificacionRenta() {
            return this.getCatalogMH('ComprasClasificacionRenta');
        },
        ...mapGetters(['getCatalogMH'])
    },
    methods: {
        getInvoiceTypeLabel(value) {
            const type = this.invoiceTypes.find((item) => String(item.value) === String(value));
            if (type) return type.text;

            const fallbackLabels = {
                CCF: 'Crédito Fiscal',
                FCF: 'Consumidor Final',
                NC: 'Nota de Crédito',
                ND: 'Nota de Débito',
                FE: 'Factura Exportación',
                DDM: 'Declaración de Mercancías',
                MDI: 'Mandamiento de Ingreso',
                RSI: 'Recibo o documento sin IVA',
                FI: 'Factura de Importación',
                FNS: 'Factura de sujeto excluido',
            };

            return fallbackLabels[value] || value || '';
        },
        getPurchaseDocumentNumberLabel() {
            return String(this.editInvoiceData.PurchaseDocumentType) === '2'
                ? 'Código de generación'
                : 'Correlativo de factura';
        },
        getPurchaseDocumentTypeLabel(value) {
            const documentTypes = {
                1: 'Documento físico',
                2: 'Comprobante electrónico',
            };

            return documentTypes[value] || value || '';
        },
        shouldShowElectronicDocumentFields() {
            return this.editInvoiceData.PurchaseOrderType !== 'FNS'
                && String(this.editInvoiceData.PurchaseDocumentType) === '2';
        },
        getGravada(e){
            if(e.ItemExento > 0 || e.ItemNoSujeto > 0) return 0.00;

            return parseFloat(e.ItemQuantity * e.ItemUnitCost);
        },
        onExporting(e) {
            const exportEvent = e ?? {
                component: this.$refs.purchaseOrderDetailsGrid?.instance
            };
            if (!exportEvent.component) {
                return;
            }
            const fileName = "Detalle_de_compra_" + (this.purchaseOrderId ?? '');
            printToExcel(exportEvent, fileName, null, '', false, false);
        },
        closeAlert() {
            this.alert.show = false;

        }
        ,
        acceptAlert() {
            this.alert.show = false;

        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        confirmdeleteOrder() {
            this.showAlert("question", "Confirmación", "¿Está seguro de eliminar esta orden de compra?", "deleteOrder");
        },
        confirmDeleteProcessedOrder() {
            this.showAlert("question", "Confirmación", "¿Está seguro de eliminar esta orden de compra?", "deleteProcessedOrder");
        },
        Preview_image() {
            this.url = URL.createObjectURL(this.image)
        },
        onEditorChange(e) {
            this.purchaseOrderData.PurchaseOrderInternalNote = e.html
        },
        deleteOrder() {
            this.showDelAlert = false;
            this.loading = true
            this.$API.orders.deleteOrder(this.purchaseOrderId)
                .then((resepone) => {
                    this.loading = false;
                    this.$toasted.success(resepone.message);
                    this.$emit('close')
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.showAlert("danger", "Error", "Ha ocurrido un error en eliminar la orden de compra seleccionada.");
                })
                
        },
        deleteProcessedOrder() {
            this.showDelAlert = false;
            this.loading = true
            this.$API.orders.logicalDeleteOrder(this.purchaseOrderId)
                .then((res) => {
                    console.log(res);
                    
                    this.showAlert("success", "Ordem de compra eliminada", "La orden de compra ha sido eliminada correctamente");
                    this.$toasted.success(res.message);
                    // El modal se destruye al cerrar: el aviso de tienda va en un toast.
                    if (res && res.externalStoreSyncWarning) {
                        this.$toasted.info(res.externalStoreSyncWarning, { duration: 10000 });
                    }
                    this.$emit('close');
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.showAlert("danger", "Error", "Ha ocurrido un error en eliminar la orden de compra seleccionada.");
                });
        },

        updatePurchaseOrder() {
            this.$API.orders.updateStateOrder({ id: this.order.data.ID_PurchaseOrder })
                .then(() => {
                    this.$toasted.success("La orden de compra ha sido procesada");
                    this.showDelAlert = false;
                    this.$emit('close')
                })
                .catch(err => {
                    this.$toasted.success(err.message);
                })

        },

        isCustomPeriodEnabled(value) {
            return value === true || value === 1 || value === '1' || value === 'true';
        },

        getCustomPeriodLabel() {
            if (!this.isCustomPeriodEnabled(this.purchaseOrderData.CustomCSVPeriodFlag)) {
                return 'Según la fecha de la orden';
            }

            const month = this.customPeriodMonths.find((item) =>
                Number(item.value) === Number(this.purchaseOrderData.CustomCSVPeriodMonth)
            );
            return `${month ? month.text : 'Mes no definido'} ${this.purchaseOrderData.CustomCSVPeriodYear || ''}`.trim();
        },

        editOrder() {
            if (this.out) {
                let search = {
                    business: JSON.parse(localStorage.getItem("user")).businessid || "",
                    branch: JSON.parse(localStorage.getItem("user")).branch || ""
                }
                this.$API.providers.getProviders(search)
                    .then(response => {
                        console.log(response)
                        let data = response.find(provider => provider.ID_Provider == this.purchaseOrderData.ID_Provider)

                        this.$store.dispatch('addWindow', {
                            name: 'providerData',
                            component: 'ProviderData',
                            unique: false,
                            meta: { provider: data }
                        }).then(() => {
                            this.$store.commit('providersData/setOrderDetails', this.orderItems)
                            this.$store.commit('providersData/setOrder', this.purchaseOrderData)
                            this.$emit('close')
                            this.$store.commit('providersData/changeView', 'tab-2')
                            this.$store.commit('providersData/setReloaders', 'reloadAddPurchase')
                        })
                    })

            }
            else {
                this.$store.commit('providersData/setOrderDetails', this.orderItems)
                this.$store.commit('providersData/setOrder', this.purchaseOrderData)
                this.$emit('close')
                this.$store.commit('providersData/changeView', 'tab-2')
                this.$store.commit('providersData/setReloaders', 'reloadAddPurchase')
            }
        },

        // Métodos para clasificación
        startEditClassification() {
            this.editClassificationData = {
                ClasificationRent: this.purchaseOrderData.ClasificationRent || '2',
                SectorProveedores: this.purchaseOrderData.SectorProveedores,
                TipoIngresoProveedores: this.purchaseOrderData.TipoIngresoProveedores,
            };
            this.editingClassification = true;
        },

        cancelEditClassification() {
            this.editingClassification = false;
            this.editClassificationData = {};
        },

        async saveClassification() {
            try {
                const res = await this.$API.orders.updatePurchaseOrderClassification({
                    id: this.purchaseOrderId,
                    ClasificationRent: this.editClassificationData.ClasificationRent,
                    SectorProveedores: this.editClassificationData.SectorProveedores,
                    TipoIngresoProveedores: this.editClassificationData.TipoIngresoProveedores,
                });

                if (res.success) {
                    // Actualizar purchaseOrderData con los nuevos valores
                    this.purchaseOrderData.ClasificationRent = this.editClassificationData.ClasificationRent;
                    this.purchaseOrderData.SectorProveedores = this.editClassificationData.SectorProveedores;
                    this.purchaseOrderData.TipoIngresoProveedores = this.editClassificationData.TipoIngresoProveedores;
                    this.editingClassification = false;
                    this.$toasted.success('Clasificación actualizada correctamente.');
                }
            } catch (error) {
                console.error(error);
                this.showAlert('danger', 'Error', 'No se pudo guardar la clasificación.');
            }
        },

        // Métodos para datos de factura
        startEditInvoiceData() {
            this.editInvoiceData = {
                PurchaseOrderDate: this.order.data.PurchaseOrderDate,
                PurchaseInvoiceDate: this.order.data.PurchaseInvoiceDate,
                PurchaseOrderType: this.order.data.PurchaseOrderType,
                ID_PurchaseLegalInvoiceNumber: this.purchaseOrderData.ID_PurchaseLegalInvoiceNumber,
                PurchaseDocumentType: this.purchaseOrderData.PurchaseDocumentType,
                NumeroControl: this.purchaseOrderData.NumeroControl,
                selloRecibido: this.purchaseOrderData.selloRecibido,
                NumeroDocumentoRelacionado: this.purchaseOrderData.NumeroDocumentoRelacionado,
                CustomCSVPeriodFlag: this.isCustomPeriodEnabled(this.purchaseOrderData.CustomCSVPeriodFlag) ? 1 : 0,
                CustomCSVPeriodYear: this.purchaseOrderData.CustomCSVPeriodYear || new Date().getFullYear(),
                CustomCSVPeriodMonth: this.purchaseOrderData.CustomCSVPeriodMonth,
                paymenMethod: this.order.data.paymenMethod,
                InvoiceState: this.order.data.InvoiceState,
                days: this.order.data.days,
                NReference: this.order.data.NReference,
            };
            this.editingInvoiceData = true;
        },

        cancelEditInvoiceData() {
            this.editingInvoiceData = false;
        },

        async saveInvoiceData() {
            if (this.savingInvoiceData) return;

            try {
                const useCustomPeriod = this.isCustomPeriodEnabled(this.editInvoiceData.CustomCSVPeriodFlag);
                if (useCustomPeriod && (!this.editInvoiceData.CustomCSVPeriodYear || !this.editInvoiceData.CustomCSVPeriodMonth)) {
                    this.showAlert('warning', 'Datos incompletos', 'Debe seleccionar el mes y año del período personalizado.');
                    return;
                }

                this.savingInvoiceData = true;
                const res = await this.$API.orders.updatePurchaseOrderHeader({
                    id: this.purchaseOrderId,
                    PurchaseOrderDate: this.editInvoiceData.PurchaseOrderDate,
                    PurchaseInvoiceDate: this.editInvoiceData.PurchaseInvoiceDate,
                    CustomCSVPeriodFlag: useCustomPeriod ? 1 : 0,
                    CustomCSVPeriodYear: useCustomPeriod ? this.editInvoiceData.CustomCSVPeriodYear : null,
                    CustomCSVPeriodMonth: useCustomPeriod ? this.editInvoiceData.CustomCSVPeriodMonth : null,
                    ID_PurchaseLegalInvoiceNumber: this.editInvoiceData.ID_PurchaseLegalInvoiceNumber,
                    PurchaseDocumentType: this.editInvoiceData.PurchaseDocumentType,
                    NumeroControl: this.editInvoiceData.NumeroControl,
                    selloRecibido: this.editInvoiceData.selloRecibido,
                    NumeroDocumentoRelacionado: this.editInvoiceData.NumeroDocumentoRelacionado,
                    paymenMethod: this.editInvoiceData.paymenMethod,
                    InvoiceState: this.editInvoiceData.InvoiceState,
                    days: this.editInvoiceData.days,
                    NReference: this.editInvoiceData.NReference,
                });

                if (res.success) {
                    // Actualizar order.data y purchaseOrderData con los nuevos valores
                    this.order.data.PurchaseOrderDate = this.editInvoiceData.PurchaseOrderDate;
                    this.order.data.PurchaseInvoiceDate = this.editInvoiceData.PurchaseInvoiceDate;
                    this.order.data.PurchaseOrderType = this.editInvoiceData.PurchaseOrderType;
                    this.purchaseOrderData.PurchaseOrderDate = this.editInvoiceData.PurchaseOrderDate;
                    this.purchaseOrderData.PurchaseInvoiceDate = this.editInvoiceData.PurchaseInvoiceDate;
                    this.purchaseOrderData.PurchaseOrderType = this.editInvoiceData.PurchaseOrderType;
                    this.purchaseOrderData.ID_PurchaseLegalInvoiceNumber = this.editInvoiceData.ID_PurchaseLegalInvoiceNumber;
                    this.purchaseOrderData.PurchaseDocumentType = this.editInvoiceData.PurchaseDocumentType;
                    this.purchaseOrderData.NumeroControl = this.editInvoiceData.NumeroControl;
                    this.purchaseOrderData.selloRecibido = this.editInvoiceData.selloRecibido;
                    this.purchaseOrderData.NumeroDocumentoRelacionado = this.editInvoiceData.NumeroDocumentoRelacionado;
                    this.purchaseOrderData.CustomCSVPeriodFlag = useCustomPeriod ? 1 : 0;
                    this.purchaseOrderData.CustomCSVPeriodYear = useCustomPeriod ? this.editInvoiceData.CustomCSVPeriodYear : null;
                    this.purchaseOrderData.CustomCSVPeriodMonth = useCustomPeriod ? this.editInvoiceData.CustomCSVPeriodMonth : null;
                    this.order.data.paymenMethod = this.editInvoiceData.paymenMethod;
                    this.order.data.InvoiceState = this.editInvoiceData.InvoiceState;
                    this.order.data.days = this.editInvoiceData.days;
                    this.order.data.NReference = this.editInvoiceData.NReference;
                    this.editingInvoiceData = false;
                    this.showAlert('success', 'Datos de factura', 'Datos de factura actualizados correctamente.');
                }
            } catch (error) {
                console.error(error);
                this.showAlert('danger', 'Error', 'No se pudo guardar los datos de factura.');
            } finally {
                this.savingInvoiceData = false;
            }
        },

        // Métodos helper para labels
        getClasificationRentLabel(codigo) {
            if (!codigo) return 'No especificado';
            const item = this.comprasClasificacionRenta.find(i => i.Codigo == codigo);
            return item ? item.Valores : 'No encontrado';
        },

        getSectorLabel(codigo) {
            if (!codigo) return 'No especificado';
            const item = this.sectorProveedoresList.find(i => i.Codigo == codigo);
            return item ? item.Valores : 'No encontrado';
        },

        getTipoIngresoLabel(codigo) {
            if (!codigo) return 'No especificado';
            const item = this.tipoIngresoProveedoresList.find(i => i.Codigo == codigo);
            return item ? item.Valores : 'No encontrado';
        },


    }
}
</script>

<style scoped>
.box {
    border-style: solid;
    border-color: black;
    border-width: 1px;
    background-color: white;
    padding: 0.5rem;
    border-radius: 15px;
    margin: 0.5rem;
}

.input-group.mb-3 {
    text-align: center;
}

.input-group-prepend {
    text-align: left;
}

input.form-control {
    background: #d6eaf3;
    border: 1px solid #1976d2;
    text-align: center;
    max-width: 80px;
    height: 30px;
    border-radius: 20px;
}

.filter-btn {
    position: absolute;
    top: 60px;
    left: 30px;
    z-index: 9;
}

.p-relative {
    position: relative;
}

.btnsave {
    background-color: #00a178 !important;
    color: white;
    width: 90%;
}

.btnsave2 {
    background-color: #00a178 !important;
    color: white;
}

.btnclean {
    background-color: #f29d35 !important;
    color: white;
    width: 60%;
}

.btn-add {
    background-color: #3498db !important;
    color: white;
}

.export-detail-button {
    width: 100%;
}

@media (min-width: 960px) {
    .export-detail-button {
        width: auto;
    }
}

.scroll-bar {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
}

/* width */
.scroll-bar::-webkit-scrollbar {
    width: 10px;
}

/* Track */
.scroll-bar::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
}

/* Handle */
.scroll-bar::-webkit-scrollbar-thumb {
    background: #262626;
    border-radius: 10px;
}

.navbar {
    display: flex;
    height: 4.5rem;
    background: #41464c;
    color: white;
    top: 0;
    align-self: flex-start;
    z-index: 100;
    position: sticky;
    justify-content: space-around;
}

.btnav {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 50%;
}

.btnblack {
    background-color: rgba(60, 60, 60, 1) !important;
    color: white;

}

.btndelete {
    background-color: #E3191E !important;
    color: white;
}

@media screen and (max-device-width: 1408px),
screen and (max-width: 1408px) {
    .navbar {
        margin-left: 0;
        margin-right: 0;
        height: auto;
        text-align: center;
    }

    .btnav {
        display: flex;
        flex-direction: column;
        /* align-items: center; */
    }

    .input-group-prepend {
        text-align: center;
    }
}

.tabs {
    width: 100%;
    padding: 10px;
    background-color: rgba(60, 60, 60, 1);
    color: white !important;
    border-style: solid;
    border-color: black;
    border-width: 1px;
    border-radius: 10px;

}

.tabsContent {
    width: 100%;
    padding: 10px;
    background-color: #F29D35;
    color: white !important;
    border-style: solid;
    border-color: black;
    border-width: 1px;
    border-radius: 10px;

}

.tabs:hover {
    background-color: rgba(80, 80, 80, 1);
    cursor: pointer;
}

.tabsContent:hover {
    background-color: #FFB266;
    cursor: pointer;
}
@media screen and(max-width: 600px) {
    .font-size{
        font-size:20px !important;
    }
}
</style>
